import type { Event, EventType } from "../reducers/apiTypes";
import {
    categoryColor,
    categoryLabel,
    formatEventTimeRange,
    getEventEndIso,
    isMultiDayEvent,
} from "./eventDisplay";

const CATEGORY_BG: Record<string, string> = {
    pink: "#fce7f3",
    green: "#dcfce7",
    orange: "#ffedd5",
    purple: "#ede9fe",
    blue: "#dbeafe",
};

const CATEGORY_BORDER: Record<string, string> = {
    pink: "#e879a8",
    green: "#4ade80",
    orange: "#f97316",
    purple: "#a78bfa",
    blue: "#60a5fa",
};

export type IlamyCalendarView = "month" | "week" | "day";

export function categoryColorHex(eventType: EventType | string): string {
    const color = categoryColor(eventType);
    return CATEGORY_BORDER[color] ?? CATEGORY_BORDER.orange;
}

export function categoryBackgroundHex(eventType: EventType | string): string {
    const color = categoryColor(eventType);
    return CATEGORY_BG[color] ?? CATEGORY_BG.orange;
}

export function eventsToIlamyCalendar(events: Event[]) {
    return events.map((event) => {
        const multiDay = isMultiDayEvent(event);
        const start = event.datetime;
        const end = getEventEndIso(event);

        return {
            id: event.id,
            title: event.name,
            start,
            end,
            allDay: multiDay,
            location: event.address,
            description: event.description,
            backgroundColor: categoryBackgroundHex(event.event_type),
            color: categoryColorHex(event.event_type),
            data: { sourceEvent: event },
        };
    });
}

export function ilamyEventToAppEvent(
    calendarEvent: { id: string | number; data?: { sourceEvent?: Event } }
): Event | null {
    return calendarEvent.data?.sourceEvent ?? null;
}

export function formatCalendarViewLabel(view: IlamyCalendarView): string {
    if (view === "day") return "Day";
    if (view === "week") return "Week";
    return "Month";
}

export function compactEventLabel(event: Event): string {
    return `${formatEventTimeRange(event)} · ${categoryLabel(event.event_type)}`;
}

